document.addEventListener("DOMContentLoaded", () => {
  const selectedValueSpans = document.querySelectorAll("[data-selected-swatch-value]"); // Fixed selector
  const keywords = ["Leather", "Fabric", "Velvet"];

  selectedValueSpans.forEach((item) => {
    const name = item.dataset.selectedSwatchValue;

    if (["Upholstery Color", "Upholstery Colors", "Color", "Colors", "Colour", "Colours"].includes(name)) {
      let value = item.textContent.trim();

      // Hide all keyword tags initially
      keywords.forEach(key => {
        const tagElement = document.querySelector(`#${key}-tag`);
        if (tagElement) tagElement.classList.add("hidden");
      });

      // Remove matched keywords and show the corresponding tag
      keywords.forEach(key => {
        if (value.includes(key)) {
          value = value.replace(key, "").trim();
          const tagElement = document.querySelector(`#${key}-tag`);
          if (tagElement) tagElement.classList.remove("hidden");
        }
      });

      // Update the item's text content only once after all modifications
      item.textContent = value;
    }
  });
});
